import React from "react";
import IIcon from "../../interfaces/IIcon";

const CarIcon = (props: IIcon) => (
    <svg
        {...props}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 496.474 496.474"
        // style={{ enableBackground: "new 0 0 496.474 496.474" }}
        xmlSpace="preserve"
        dangerouslySetInnerHTML={{
            __html: `<path
        style="fill:#E95353;"
        d="M489.544,269.628c-0.729-14.739-6.206-28.858-15.205-40.572
c-20.294-26.422-24.25-47.399-24.25-47.399c-15.934-41.751-30.099-69.57-40.51-87.226c-10.954-18.541-29.898-31.03-51.262-33.776
c-42.961-5.554-177.23-5.554-220.191,0c-21.349,2.762-40.293,15.251-51.247,33.776c-10.411,17.656-24.56,45.475-40.51,87.226
c0,0-3.956,20.977-24.25,47.399c-8.983,11.714-14.476,25.833-15.189,40.572c-1.536,31.977,7.727,39.005,16.012,111.368
c0.652,5.694,5.461,9.976,11.202,9.976h428.203c5.741,0,10.55-4.298,11.202-9.976c2.327-20.294,9.232-61.456,9.232-61.456
C488.83,299.076,490.149,282.397,489.544,269.628z"
    />
    <path
        style="fill:#168DE2;"
        d="M441.074,179.982c-12.567-31.449-25.383-58.911-38.136-80.803
c-9.666-16.555-26.717-28.113-45.583-30.642c-43.055-5.71-175.476-5.663-218.221,0c-18.866,2.529-35.918,14.088-45.584,30.642
c-12.924,22.171-25.91,50.005-38.291,80.803C183.662,190.082,312.655,190.082,441.074,179.982z"
    />
    <path
        style="fill:#FFFFFF;"
        d="M422.844,216.349c-4.903,1.536-9.464,3.693-13.281,5.834c-6.951,3.879-14.088,7.494-21.535,10.318
c-12.35,4.686-14.445,11.683-14.445,11.683c-0.372,0.481-0.729,0.962-1.071,1.458c-9.371,13.917,2.932,32.442,19.549,30.084
c24.033-3.398,43.83-10.364,53.884-14.398c5.756-2.312,10.255-7.121,11.729-13.157c0.14-0.574,0.264-1.148,0.372-1.707
C461.74,226.543,442.191,210.314,422.844,216.349z"
    />
    <path
        style="fill:#FFE21F;"
        d="M448.522,327.857h-26.733c-4.018,0-6.035,4.856-3.196,7.711l26.733,26.733
c2.839,2.839,7.711,0.822,7.711-3.196v-26.733C453.036,329.874,451.019,327.857,448.522,327.857z"
    />
    <path
        style="fill:#454545;"
        d="M473.547,380.965c-0.652,5.71-5.477,10.007-11.217,10.007h-51.433v29.851
c0,10.566,8.564,19.146,19.146,19.146h32.303c10.566,0,19.146-8.564,19.146-19.146v-93.448
C479.366,340.315,475.239,366.179,473.547,380.965z"
    />
    <path
        style="fill:#ED6262;"
        d="M496.107,159.083c-1.552-6.951-8.083-11.667-15.205-11.667h-12.909
c-8.27,0-14.972,6.703-14.972,14.972v9.2h-6.842l3.925,9.325h15.05c7.789,0,15.5-1.676,22.575-4.918
C494.105,173.078,497.674,166.096,496.107,159.083z"
    />
    <circle style="fill:#FFBD49;" cx="431.315" cy="240.46" r="18.82" />
    <circle style="fill:#FFDB6F;" cx="393.458" cy="255.308" r="13.824" />
    <polygon
        style="fill:#6F6F6F;"
        points="357.634,255.324 336.021,292.963 160.452,292.963 138.839,255.324 "
    />
    <path
        style="fill:#FFFFFF;"
        d="M123.945,245.642c-0.326-0.496-0.683-0.977-1.071-1.458c0,0-2.095-6.997-14.445-11.683
c-7.447-2.824-14.569-6.439-21.535-10.318c-3.832-2.141-8.378-4.298-13.281-5.834c-19.332-6.051-38.896,10.193-35.219,30.115
c0.109,0.574,0.233,1.133,0.357,1.707c1.474,6.035,5.973,10.845,11.729,13.157c10.054,4.034,29.851,11,53.9,14.398
C121.012,278.084,133.316,259.559,123.945,245.642z"
    />
    <path
        style="fill:#FFE21F;"
        d="M74.684,327.857H47.951c-2.498,0-4.515,2.017-4.515,4.515v26.733c0,4.018,4.872,6.035,7.711,3.196
l26.733-26.733C80.719,332.729,78.702,327.857,74.684,327.857z"
    />
    <path
        style="fill:#777777;"
        d="M426.226,374.511c-27.834-48.159-59.842-46.654-59.842-46.654H130.073
c0,0-31.992-1.505-59.842,46.654H22.119l0.59,6.206c0.543,5.834,5.415,10.256,11.248,10.256h428.56
c5.834,0,10.705-4.422,11.249-10.255l0.59-6.206L426.226,374.511L426.226,374.511z"
    />
    <path
        style="fill:#454545;"
        d="M34.143,390.988c-5.741,0-10.566-4.313-11.217-10.007c-1.691-14.786-5.834-40.665-7.944-53.589
v93.448c0,10.566,8.564,19.146,19.146,19.146H66.43c10.566,0,19.146-8.564,19.146-19.146v-29.851H34.143z"
    />
    <path
        style="fill:#ED6262;"
        d="M43.436,171.588v-9.2c0-8.27-6.703-14.972-14.957-14.972H15.571c-7.121,0-13.653,4.717-15.205,11.667
c-1.567,6.997,2.017,13.995,8.378,16.896c7.09,3.243,14.786,4.918,22.575,4.918h15.05l3.925-9.325h-6.858V171.588z"
    />
    <circle style="fill:#FFBD49;" cx="65.142" cy="240.46" r="18.82" />
    <circle style="fill:#FFDB6F;" cx="103.03" cy="255.308" r="13.824" />
    <g>
        <path
            style="fill:#6F6F6F;"
            d="M348.294,341.029H148.179c-3.134,0-5.663,2.544-5.663,5.663c0,3.134,2.529,5.663,5.663,5.663
    h200.099c3.134,0,5.663-2.544,5.663-5.663C353.957,343.558,351.412,341.029,348.294,341.029z"
        />
        <path
            style="fill:#6F6F6F;"
            d="M348.294,363.635H148.179c-3.134,0-5.663,2.544-5.663,5.663c0,3.134,2.529,5.663,5.663,5.663
    h200.099c3.134,0,5.663-2.544,5.663-5.663C353.957,366.164,351.412,363.635,348.294,363.635z"
        />
    </g>
    <path
        style="fill:#3AA2EB;"
        d="M420.098,132.009v1.939c0,7.804-6.408,14.057-14.367,13.731c-7.339-0.465-12.955-7.028-12.955-14.522
v-27.834c0-6.563-5.461-11.559-12.024-11.388c-0.155,0-0.155,0-0.31,0c0,0,0,0-0.155,0c-6.563-0.155-12.024,4.841-12.024,11.388
v25.181c0,7.804-6.718,14.057-14.522,13.576c-7.339-0.31-12.955-7.028-12.955-14.367v-21.892c0-6.563-5.461-12.024-12.179-12.024
h-0.931c-6.253,0-11.404,5.151-11.404,11.404v28.47c0,7.804-6.563,14.041-14.522,13.731c-7.339-0.465-12.8-7.028-12.8-14.522V96.712
c0-6.082-5.306-11.233-11.559-10.768h-0.931c-6.408,0-11.543,5.151-11.543,11.404v39.021c0,7.494-6.082,13.731-13.731,13.731
c-7.339,0-13.421-5.927-13.576-13.265v-32.752c0-7.494-5.616-14.041-12.955-14.522c-7.959-0.31-14.367,5.927-14.367,13.731
l-0.155,30.255c0,7.804-6.392,14.041-14.367,13.731c-7.199-0.45-12.66-6.78-12.878-13.948V97.829c0-7.37-5.539-13.964-12.909-14.398
c-7.897-0.341-14.414,5.88-14.414,13.7v37.19c-0.217,7.618-6.609,13.684-14.445,13.374c-7.339-0.465-12.8-7.028-12.8-14.522v-27.85
c0-6.563-5.616-11.559-12.179-11.388c-0.155,0-0.155,0-0.155,0c-0.155,0-0.155,0-0.155,0c-6.718-0.155-12.179,4.841-12.179,11.388
v25.181c0,7.804-6.563,14.057-14.367,13.576c-6.796-0.264-11.854-5.942-12.722-12.521c-7.215,14.941-14.367,31.123-21.318,48.407
c128.403,10.116,257.412,10.116,385.815,0C434.139,162.636,427.126,146.655,420.098,132.009z"
    />`,
        }}
    ></svg>
);
export default CarIcon;
